module.exports = __webpack_public_path__ + "img/QDAP-insurance-filled.10b0230.png";